import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import cn from 'clsx';
import styles from './styles.module.css';
import {getTotalPayNow} from 'utils/payments';

type Props = {
  total: string;
  fee: string;
  alreadyPaid: string | null | undefined;
  currencySymbol?: string;
  button?: ReactNode;
  totalPaid?: string;
  className?: string;
};
function PaymentTotals({
  total,
  fee,
  alreadyPaid,
  button,
  currencySymbol,
  totalPaid,
  className,
}: Props) {
  const {t} = useTranslation('check-out');

  return (
    <div
      className={cn(
        styles.paymentBox__buttonContainer,
        className,
        'checkout-summary-box__pay-button-container',
      )}
    >
      <div className={cn(styles.paymentBox__row, 'checkout-summary-box__row')}>
        <div className={cn(styles.paymentBox__item, 'checkout-summary-box__item')}>
          <div
            className={cn(styles.paymentBox__rowTitle, 'checkout-summary-box__row-title')}
          >
            <span className="font-semibold">{t('total_to_pay')}</span>
            {<span>{t('fee_included', {fee})}</span>}
          </div>
          <div
            className={cn(styles.paymentBox__rowPrice, 'checkout-summary-box__row-price')}
          >
            {currencySymbol}
            {getTotalPayNow(0, total, alreadyPaid) || 0}
          </div>
        </div>
      </div>
      {Boolean(parseFloat(alreadyPaid || '0')) && (
        <div
          className={cn(
            styles.paymentBox__row,
            styles.alreadyPaid,
            'checkout-summary-box__row already-paid',
          )}
        >
          <div
            className={cn(
              styles.paymentBox__item,
              'font-normal checkout-summary-box__item',
            )}
          >
            <div
              className={cn(
                styles.paymentBox__rowTitle,
                'checkout-summary-box__row-title',
              )}
            >
              <span className="font-normal">{t('already_paid')}</span>
            </div>

            <div
              className={cn(
                styles.paymentBox__rowPrice,
                'checkout-summary-box__row-price',
              )}
            >
              {currencySymbol}
              {alreadyPaid}
            </div>
          </div>
        </div>
      )}
      {Boolean(parseFloat(totalPaid || '0')) && (
        <div
          className={cn(
            styles.paymentBox__row,
            styles.alreadyPaid,
            'checkout-summary-box__row already-paid',
          )}
        >
          <div
            className={cn(
              styles.paymentBox__item,
              'font-normal checkout-summary-box__item',
            )}
          >
            <div
              className={cn(
                styles.paymentBox__rowTitle,
                'checkout-summary-box__row-title',
              )}
            >
              <span className="font-normal">{t('already_paid')}</span>
            </div>

            <div
              className={cn(
                styles.paymentBox__rowPrice,
                'checkout-summary-box__row-price',
              )}
            >
              {currencySymbol}
              {totalPaid}
            </div>
          </div>
        </div>
      )}

      {button}
    </div>
  );
}

export {PaymentTotals};
